
import { useStore, mapState } from 'vuex'
import { defineComponent } from 'vue'
import { formatSize } from '@remote/utils/index'
import { isLargeViewPort } from '@remote/utils/base'
import '@remote/assets/css/speed.scss'

function logs (..._args) {
  console.log('[下载速度设置]', ..._args)
}

const speedRange = [
  {
    percent: 0,
    min: 0, max: 60,
    stepRange: 32,
  },
  {
    percent: 32,
    min: 60, max: 1024,
    stepRange: 32,
  },
  {
    percent: 64,
    min: 1 * 1024, max: 50 * 1024,
    stepRange: 32,
  },
  {
    percent: 100,
    min: 50 * 1024, max: 115 * 1024,
    stepRange: 36,
  },
]
let isModify = false

export default defineComponent({
  name: 'SpeedSetting',
  props: {
    speedLimit: {
      type: Number,
      default: -1,
    },
  },
  emits: ['setSpeed', 'change'],
  setup: () => {
    const store = useStore()
    return { store }
  },
  data () {
    return {
      marks: {
        0: '60KB',
        32: '1MB',
        64: '50MB',
        100: '全速',
      },
      dragNum: 0,
      isDrag: false,
      domRect: {
        width: 343,
        height: 16,
        left: 16,
        top: 10,
        x: 16,
        y: 0,
      },
      beforeSpeedTxt: '',
    }
  },
  computed: {
    ...mapState(['all', 'user', 'currentSpped', 'curDeviceRunner']),
    isLargeViewPort () {
      return isLargeViewPort()
    },
    percent (): number {
      return Math.floor((this.dragNum / this.domRect.width) * 100)
    },
    speed (): number {
      if (this.percent >= 95) return -1
      const index = speedRange.findIndex(v => v.percent >= this.percent)
      const range = speedRange[index]
      const size = Math.abs(((range.max - range.min) / range.stepRange) * (this.percent + range.stepRange - range.percent)) + range.min
      // console.log('speed', range, this.percent, size)
      return size * 1024
    },
    speedTxt (): string {
      if (this.percent >= 95) return '无限制'
      return formatSize(isModify ?  this.speed : this.speedLimit) + '/s'
    },
  },
  watch: {
    isDrag (newVal: boolean, oldVal: boolean) {
      // 释放时进行修改事件通知
      if (!newVal && oldVal) {
        this.$emit('change', { download_speed_limit: Math.floor(this.speed) })
      }
    },
    speed (speed: number) {
      if (!isModify) return
      // 未释放时不进行事件触发
      if (this.isDrag) return
      this.$emit('change', { download_speed_limit: Math.floor(speed) })
    },
    speedLimit () {
      this.calculate()
      isModify = false
    },
  },
  mounted () {
    window.addEventListener('touchmove', this.handleDrag.bind(this), false)
    window.addEventListener('mousemove', this.handleDrag.bind(this), false)
    window.addEventListener('mouseup', () => this.isDrag = false)
    this.calculate()
  },
  beforeUnmount () {
    this.changeSpeed()
  },
  unmounted () {
    window.removeEventListener('touchmove', this.handleDrag)
    window.removeEventListener('mousemove', this.handleDrag)
  },
  methods: {
    calculate () {
      const rect = (this.$refs.speedProgress as HTMLElement).getClientRects()[0]
      if (rect) {
        this.domRect = {
          left: rect.left,
          top: rect.top,
          width: rect.width,
          height: rect.height,
          x: rect.x,
          y: rect.y,
        }
        const percent = this.speedLimit < 0 ? 100 : this.size2percent(this.speedLimit)
        this.dragNum = rect.width * percent / 100
      }
      this.beforeSpeedTxt = this.speedTxt
    },
    changeSpeed () {
      if ((this.speed > 0 || this.speed === -1) && this.speedTxt !== this.beforeSpeedTxt) {
        this.$emit('setSpeed', { download_speed_limit: Math.floor(this.speed) })
      }
    },
    handleDrag (event) {
      if (!this.isDrag) return
      const w = this.domRect.width
      if (event?.targetTouches) {
        const touch =  Math.round(event.targetTouches[0].pageX)
        if (touch < 0) {
          this.dragNum = this.isLargeViewPort ? 0 : 8
        } else if (touch > w) {
          this.dragNum = this.isLargeViewPort ? w : w - 10
        } else {
          this.dragNum = touch - this.domRect.left
        }
      } else {
        const touch = event.pageX - this.domRect.left
        if (touch < 0) {
          this.dragNum = this.isLargeViewPort ? 0 : 8
        } else if (touch >= w) {
          this.dragNum = this.isLargeViewPort ? w : w - 10
        } else {
          this.dragNum = touch 
        }
      }
      if (this.dragNum < 0) {
        this.dragNum = 0
      }
      isModify = true
    },
    handleClick (event) {
      this.dragNum = event.pageX - this.domRect.left
      isModify = true
    },
    size2percent (size: number) {
      const speed = size / 1024
      const index = speedRange.findIndex(v => v.max >= speed)
      const range = speedRange[index]
      const percent = (speed - range.min) / ((range.max - range.min) / range.stepRange) + speedRange[index - 1]?.percent || 0
      logs('size2percent', size, index, range, percent)
      return percent
    },
  },
})
